<template>
  <footer class="footer-livratos">
    <!-- CTA -->
    <section class="cta-section">
      <div class="container cta-wrapper">
        <div class="row align-items-center">
          <div class="col-lg-7">
            <h3>Une Démo ? Un besoin ?</h3>
            <p>
              Parlons-en ! Livratos accompagne vos projets de logistique et de
              livraison sur-mesure.
            </p>
          </div>
          <div class="col-lg-5 text-lg-end text-center mt-3 mt-lg-0">
            <a href="/contact" class="btn btn-light fw-semibold px-4">
              Nous contacter
            </a>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer -->
    <section class="main-footer">
      <div class="container">
        <div class="row gy-5">
          <div class="col-md-6">
            <h5 class="footer-title">Livratos</h5>
            <p>
              Votre partenaire logistique intelligent et écoresponsable. Suivez
              vos livraisons, optimisez vos flux, simplifiez votre quotidien.
            </p>
            <ul class="social-icons">
              <li>
                <a href="#"><i class="fab fa-facebook-f"></i></a>
              </li>
              <li>
                <a href="#"><i class="fab fa-twitter"></i></a>
              </li>
              <li>
                <a href="#"><i class="fab fa-linkedin-in"></i></a>
              </li>
            </ul>
          </div>

          <div class="col-md-3">
            <h5 class="footer-title">Liens utiles</h5>
            <ul class="footer-links">
              <li><a href="/about">Livratos</a></li>
              <li>
                <a href="/livraisons-fournisseurs-btp">Fournisseurs BTP</a>
              </li>
              <li><a href="/missions-pour-livreurs">Livreurs</a></li>
              <li><a href="/livraison-sur-chantier">Artisan</a></li>
            </ul>
          </div>

          <div class="col-md-3">
            <h5 class="footer-title">Nous contacter</h5>
            <p><i class="fas fa-envelope me-2"></i>contact@livratos.fr</p>
            <p><i class="fas fa-phone me-2"></i>+33 7 88 97 32 67</p>
            <p><i class="fas fa-map-marker-alt me-2"></i>Paris, France</p>
          </div>
        </div>
      </div>
      <div
        class="app-availability d-flex flex-column align-items-end mx-lg-5 mt-4"
      >
        <span class="label">Disponible sur</span>
        <div class="app-availability__icons">
          <span>
            <i class="fab fa-android"></i>
            Android
          </span>
          <span>
            <i class="fab fa-apple"></i>
            iOS
          </span>
          <span>
            <i class="fas fa-desktop"></i>
            PC
          </span>
        </div>
      </div>
    </section>

    <div class="copyright text-center py-3 d-flex flex-column">
      <a href="/mentions"
        >© {{ new Date().getFullYear() }} Livratos. Tous droits réservés.</a
      >
      <a class="malalink" href="https://livratos.app">Powered by Livratos</a>
    </div>
  </footer>
</template>

<style lang="scss" scoped>
.footer-livratos {
  background-color: white;
  color: $color-text;

  .cta-section {
    background: black;
    color: white;
    padding: 40px 0;
    border-radius: 12px;
    margin: 0 20px;
    transform: translateY(-60px);
    box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

    h3 {
      font-weight: 700;
      margin-bottom: 10px;
      color: $color-primary;
    }

    p {
      margin-bottom: 0;
    }

    .btn {
      background-color: black;
      color: $color-primary;
      transition: 0.3s ease;

      &:hover {
        background-color: darken(white, 5%);
        color: $color-darker;
      }
    }
  }

  .main-footer {
    padding: 80px 20px 40px;

    .footer-title {
      font-size: 1.25rem;
      font-weight: 600;
      margin-bottom: 1rem;
      color: $color-primary;
    }
    & p {
      max-width: 500px;
    }

    .footer-links {
      list-style: none;
      padding: 0;

      li {
        margin-bottom: 8px;

        a {
          text-decoration: none;
          color: $color-text-grey;
          font-size: 0.95rem;

          &:hover {
            color: $color-primary;
          }
        }
      }
    }

    .social-icons {
      list-style: none;
      padding: 0;
      display: flex;
      gap: 10px;
      margin-top: 1rem;

      a {
        display: inline-block;
        width: 32px;
        height: 32px;
        border-radius: 50%;
        background: $color-primary;
        color: white;
        text-align: center;
        line-height: 32px;
        transition: 0.3s ease;

        &:hover {
          background: darken($color-primary, 10%);
        }
      }
    }

    .app-availability {
      margin-top: 1.2rem;
      font-size: 0.9rem;
      display: flex;
      flex-direction: column;
      gap: 0.35rem;

      .label {
        color: $color-text;
        font-weight: 600;
      }

      &__icons {
        display: flex;
        flex-wrap: wrap;
        gap: 0.5rem 1rem;

        span {
          display: inline-flex;
          align-items: center;
          gap: 0.35rem;
          color: $color-primary;

          i {
            font-size: 1rem;
            color: $color-primary;
          }
        }
      }
    }
  }

  .copyright {
    background: black;
    font-size: 0.95rem;
    margin-top: -20px;

    & a {
      text-align: center;
      color: $color-primary;
      margin-bottom: 5px;
      text-decoration: none;
    }

    .malalink {
      color: $color-text-grey;
      font-size: 0.85rem;
    }
  }
}
</style>
